import moment from "moment";

export const getPagination = ({ pagination }) => pagination;
export const plenaria_empty = () => ({
  conselho_id: null,
  titulo: null,
  tipo: "ordinaria",
  data_reuniao: moment().format("Y-MM-DD 16:00"),
  presencas_externas: [],
  introducao: "",
  arquivos: [],
  pautas: [],
  presencas: [],
});
